import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { rem } from "./auth-service-tools172.js";
import "react";

function RadioIcon(_ref) {
  let {
    size,
    style,
    ...others
  } = _ref;
  return /* @__PURE__ */jsxRuntimeExports.jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 5 5",
    style: {
      width: rem(size),
      height: rem(size),
      ...style
    },
    "aria-hidden": true,
    ...others,
    children: /* @__PURE__ */jsxRuntimeExports.jsx("circle", {
      cx: "2.5",
      cy: "2.5",
      r: "2.5",
      fill: "currentColor"
    })
  });
}

export { RadioIcon };